<template>
  <b-row>
    <b-col cols="12">
      <b-alert
        :show="dismissCountDownSuccess"
        dismissible
        variant="success"
        @dismissed="dismissCountDownSuccess = 0"
        @dismiss-count-down="countDownSuccessChanged"
        >{{ "Les informations PDF ont été enregistrées !" }}</b-alert
      >
      <b-alert
        :show="dismissCountDownError"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownError = 0"
        @dismiss-count-down="countDownErrorChanged"
        >{{ "Il y a un problème lors de la mise à jour de la configuration pdf !" }}</b-alert
      >
    </b-col>
    <b-col v-if="!isLoading" cols="12">
      <b-alert :show="charactersErrorPdfFooter != null" variant="danger">
        {{ charactersErrorPdfFooter }}
      </b-alert>
      <h3>Configurer le pied de page PDF</h3>
      <tiptap
        v-model="pdfFooterMessage"
        :placeholder="placeholderPdfFooterMessage"
        @update="updateTextareaPdfFooterMessage"
        @updateOnFocusOut="updatePdfFooterMessage"
      />
      <b-button
        v-if="!isNew"
        :disabled="isDisabled"
        class="button btn-blue my-4 fw-600"
        @click="updatePdfConfigs()"
      >
        Enregistrer
      </b-button>
      <b-button
        v-else
        :disabled="isDisabled"
        class="button btn-blue my-4 fw-600"
        @click="createPdfConfigs()"
      >
        Enregistrer
      </b-button>
      <b-button class="button btn-grey my-4 ml-3 fw-600" @click="GENERATE_PDF">
        Aperçu pdf
      </b-button>
    </b-col>
    <appLoader v-if="isLoading" />
  </b-row>
</template>

<script>
import ConfigurationMW from "@/middlewares/Configuration";
import ConfigurationORM from "@/store/orm-axios/models/Configuration";
import Tiptap from "@/components/snippets/Tiptap.vue";
import MediaMW from "@/middlewares/Media";
import usePDFs from "@/use/usePDFs.js";
import useAlerts from "@/use/useAlerts.js";
import PDFMW from "@/middlewares/PDF";

export default {
  components: {
    Tiptap,
  },
  data() {
    return {
      pdfFooterMessage: "",
      configuration: null,
      isPdfFooterMessage: false,
      isLoading: true,
      isDisabled: false,
      dismissCountDownSuccess: 0,
      dismissCountDownError: 0,
      isNew: false,
      placeholderPdfFooterMessage: "Entrez les pdf message",
      charactersErrorPdfFooter: null,
      limitedCharactersPerRow: 80,
      limitedRows: 4,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    configurationComputed() {
      // There will be only one configuration for each agency id
      return ConfigurationORM.query().where("agency_id", this.agencyId).first();
    },
  },
  watch: {
    configurationComputed(newValue) {
      this.configuration = newValue;
      this.getPdfConfigs();
    },
  },
  created() {
    ConfigurationMW.FETCH(this.agencyId)
      .then(() => {
        this.isLoading = false;
        this.configuration = this.configurationComputed;
        this.getPdfConfigs();
        if (!this.configuration) {
          this.isNew = true;
        }
      })
      .catch(err => {
        this.isLoading = false;
      });
  },
  methods: {
    getPdfConfigs() {
      // Get current pdf_footer value
      if (
        this.configuration &&
        this.configuration.settings &&
        this.configuration.settings.length > 0
      ) {
        this.configuration.settings.forEach(element => {
          if (element.pdf_footer) {
            this.pdfFooterMessage = element.pdf_footer;
            this.isPdfFooterMessage = true;
          }
        });
      }
    },
    setPdfConfigs() {
      // If pdf_footer exists in json, just update it
      if (this.isPdfFooterMessage) {
        this.configuration.settings.forEach(element => {
          if (element.pdf_footer) {
            element.pdf_footer = this.pdfFooterMessage;
          }
        });
      } else {
        // If json exists and pdf_footer is missing, add it to json
        if (
          this.configuration &&
          this.configuration.settings &&
          this.configuration.settings.length > 0
        ) {
          this.configuration.settings.push({
            pdf_footer: this.pdfFooterMessage,
          });
        } else if (this.configuration) {
          // If json is empty, add the pdf_footer object in an array
          this.configuration.settings = [
            {
              pdf_footer: this.pdfFooterMessage,
            },
          ];
        } else {
          // If json is null, add the pdf_footer object in an array
          this.configuration = [];
          this.configuration.settings = [
            {
              pdf_footer: this.pdfFooterMessage,
            },
          ];
        }
      }
    },
    countDownSuccessChanged(dismissCountDown) {
      this.dismissCountDownSuccess = dismissCountDown;
    },
    countDownErrorChanged(dismissCountDown) {
      this.dismissCountDownError = dismissCountDown;
    },
    updatePdfConfigs() {
      if (this.charactersErrorPdfFooter) {
        return;
      }
      this.isDisabled = true;
      this.setPdfConfigs();
      ConfigurationMW.PUT(this.configuration)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    createPdfConfigs() {
      if (this.charactersErrorPdfFooter) {
        return;
      }
      this.isDisabled = true;
      this.setPdfConfigs();
      let configurationObj = {
        agencyId: this.agencyId,
        settings: this.configuration.settings,
      };
      ConfigurationMW.POST(configurationObj)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    updatePdfFooterMessage(pdfFooterMessage) {
      this.pdfFooterMessage = pdfFooterMessage;
    },
    updateTextareaPdfFooterMessage(event) {
      let message = "";
      if (event.rowLengthExceded) {
        message = `La longueur de ligne est limitée à ${this.limitedRows}.`;
      }
      if (event.rowCharactersLengthExceded) {
        message += ` La longueur des caractères de la ligne est limitée à ${this.limitedCharactersPerRow}.`;
      }
      if (message.length > 1) {
        this.charactersErrorPdfFooter = message;
      } else {
        this.charactersErrorPdfFooter = null;
      }
    },
    GENERATE_PDF() {
      this.updatePdfConfigs();
      // check if the Agency has a logo
      const idLogoAgency = localStorage.getItem("userMediaId");
      if (idLogoAgency) {
        this.$store.state.showLoaderOverlay = true;
        MediaMW.GET_LOGO_IN_BASE64(idLogoAgency)
          .then(logo => {
            let logoInBase64 = logo["file_as_base64_string"];

            // call secondary function
            this.generateDummyPdf(logoInBase64);
          })
          .catch(err => {
            console.error(err);
            this.$store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "Impossible d'extraire le logo !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "Vous n'avez spécifié aucun logo pour votre agence !",
          html: "Accédez au profil et ajoutez un logo d'agence.",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Ajouter le logo",
          confirmButtonClass: "btn btn-primary btn-lg",
          cancelButtonText: "Pas maintenant",
        }).then(res => {
          if (res.value) {
            this.$router.push({
              name: "profile",
            });
          }
        });
      }
    },
    generateDummyPdf(logoInBase64) {
      const { generateTemplateEmptyContent, downloadDialog } = usePDFs();

      generateTemplateEmptyContent(logoInBase64, this.pdfFooterMessage).then(template => {
        PDFMW.DUMMY_PDF_CREATE_RETURN({
          dummyPdf: template,
        })
          .then(PDF => {
            downloadDialog(PDF.response.data.document, "DUMMY", "pdf");
            this.$store.state.showLoaderOverlay = false;
          })
          .catch(err => {
            console.error(err);
            this.$store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(err, "", "");
          });
      });
    },
  },
};
</script>
